import { Controller } from "@hotwired/stimulus"

// In the category form, the start/end/extend date fields only apply to
// sub-categories. Show them when a parent category is chosen, and hide (and
// clear the editable ones) when "None" is selected so a root category is not
// submitted with dates.
export default class extends Controller {
  static targets = ["parent", "fields", "clearable", "startDate", "endDate"]

  connect() {
    this.toggle()
  }

  toggle() {
    if (!this.hasParentTarget || !this.hasFieldsTarget) return

    const show = this.parentTarget.value !== ""
    this.fieldsTarget.classList.toggle("hidden", !show)

    if (!show) {
      this.clearableTargets.forEach((el) => (el.value = ""))
    }
  }

}
